import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from 'react-hot-toast';

const pageTitles = {
  '/': 'Dashboard',
  '/test-learn': 'Test & Learn',
  '/data-manager': 'Data Manager',
  '/settings': 'Settings',
};

export default function Layout() {
  const location = useLocation();

  let title = pageTitles[location.pathname];
  if (!title && location.pathname.startsWith('/models/')) {
    const slug = location.pathname.replace('/models/', '');
    title = slug
      .split('-')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <header className="topbar">
          <span className="topbar-title">{title || 'Folio Coffee Co.'}</span>
          <span className="demo-badge">Demo Mode</span>
        </header>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          className: 'toast-custom',
          duration: 4000,
        }}
      />
    </div>
  );
}
